

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';

export class DeliveriesListParams extends BaseEntity
{   
    public DeliveryDateFrom: Date; 
    public DeliveryDateUntil: Date; 
    public CompanyID: number; 
    public IsOpen: boolean; 
	
}



